import TimerTemplatePreview from '@components/templates/timerTemplatePreview';
import { CountdownPosition, TimerType } from '@/types';
import type { TimerTemplate } from '@lib/timerTemplates';

type TemplatePreviewTileProps = {
	template: TimerTemplate;
	timerType: TimerType;
	countdownPosition: CountdownPosition;
};

export default function TemplatePreviewTile({ template, timerType, countdownPosition }: TemplatePreviewTileProps) {
	const isProductContainer = timerType === TimerType.PRODUCT_CONTAINER;

	return (
		<TimerTemplatePreview template={template} countdownPosition={countdownPosition} isWide={!isProductContainer} />
	);
}
